import Highcharts from 'highcharts';
import Highmaps from 'highcharts/highmaps';
import Highstock from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
import noDataState from 'highcharts/modules/no-data-to-display';
import markerClusters from 'highcharts/modules/marker-clusters';
import variablePie from 'highcharts/modules/variable-pie';
import borderRadius from 'highcharts-border-radius';
import solidGauge from 'highcharts/modules/solid-gauge';
import exportChart from 'highcharts/modules/exporting';
import sankey from 'highcharts/modules/sankey';

import timeline from 'highcharts/modules/timeline';
import patternFill from 'highcharts-pattern-fill'; // This package is causing the Highcharts warning: Deprecated member - Highcharts.each: use Array.forEach

import { forEach } from 'lodash-es';

import DefaultOptions from './DefaultOptions';

const initCrossHairPlugin = (H) => {
  H.wrap(H.Axis.prototype, 'drawCrosshair', function proceedHandler(proceed, ...args) {
    const axis = this;
    const wasRendered = !!axis.cross;
    proceed.apply(axis, args);

    if (!wasRendered && axis.cross && axis.options.clickOnCrosshair) {
      axis.cross
        .on('click', (e) => axis.options.clickOnCrosshair(e))
        .css({ pointerEvents: 'auto' });
    } else if (axis.cross) {
      axis.cross.css({ pointerEvents: 'auto' });
    }
  });
};

const initShowMarkerOnSinglePoint = (H) => {
  H.wrap(H.Series.prototype, 'drawPoints', function onPointDraw(proceed) {
    const markerState = this.options.marker.enabled;
    if (markerState === true) {
      proceed.call(this);
      return;
    }
    const { points } = this;
    this.options.marker.enabled = true;
    if (points.length === 1) {
      points[0].marker = { enabled: true };
      proceed.call(this);
      return;
    }

    forEach(points, (point, i) => {
      const showMarker =
        !point.isNull &&
        ((points[i - 1] && points[i - 1].isNull) || !points[i - 1]) &&
        ((points[i + 1] && points[i + 1].isNull) || !points[i + 1]);

      const newPoint = point;
      if (point.marker) {
        newPoint.marker.enabled = showMarker;
      } else {
        newPoint.marker = {
          enabled: showMarker,
        };
      }
      return newPoint;
    });

    proceed.call(this);

    this.options.marker.enabled = markerState;
  });
};

const initShowUpPlotLineLabel = (H) => {
  H.wrap(H.Axis.prototype, 'getPlotLinePath', function (proceed) {
    const path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    if (path) {
      path.flat = false;
    }
    return path;
  });
};

const initNavigatorHandlesPlacement = (H) => {
  H.wrap(H.Navigator.prototype, 'drawHandle', function onDrawHandle(proceed, ...restArgs) {
    proceed.apply(this, restArgs);

    if (this.navigatorOptions.handles.customPlacement) {
      const [, index] = restArgs;
      this.handles[index].attr(this.navigatorOptions.handles.customPlacement[index]);
    }
  });
};

// noDataState module must init before setOptions: it overwrites defaultOptions.noData
noDataState(Highcharts);
noDataState(Highstock);
Highcharts.setOptions(DefaultOptions);
Highstock.setOptions(DefaultOptions);
Highmaps.setOptions(DefaultOptions);
HighchartsMore(Highcharts);
markerClusters(Highcharts);
initCrossHairPlugin(Highcharts);
initCrossHairPlugin(Highstock);
initShowMarkerOnSinglePoint(Highcharts);
initShowMarkerOnSinglePoint(Highstock);
initShowUpPlotLineLabel(Highcharts);
initNavigatorHandlesPlacement(Highstock);
borderRadius(Highcharts);
variablePie(Highcharts);
solidGauge(Highcharts);
patternFill(Highcharts);
patternFill(Highstock);
exportChart(Highstock);
exportChart(Highcharts);
timeline(Highcharts);
sankey(Highcharts);
sankey(Highstock);

Highstock.AST.allowedAttributes.push('data-points', 'data-target-id');
Highcharts.AST.allowedAttributes.push('data-points', 'data-target-id');
Highmaps.AST.allowedAttributes.push('data-points', 'data-target-id');

const chartTypesList = ['chart', 'mapChart', 'stockChart'];
const chartMapper = {
  chart: Highcharts,
  mapChart: Highmaps,
  stockChart: Highstock,
};

export default (type = 'chart') =>
  chartTypesList.includes(type) ? chartMapper[type] : chartMapper.chart;
